import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import GuaranteeForChange from "../../../components/guaranteeForChange";
import GuaranteeInAccount from "../../../components/guaranteeInAccount";
import LoadingOverlay from 'react-loading-overlay';

const GuaranteeReplacement = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Tablero de Control \ Sustitución"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={2} justify="flex-end">
                                <Grid item>
                                    <Button
                                        label="Regresar"
                                        style={{'float': 'right'}}
                                        className="p-button-secondary"
                                        onClick={props.handleReturnButton}/>
                                </Grid>
                                <Grid item>
                                    <Button label="Agregar Garantía" className="p-button-secondary"
                                            onClick={props.redirectAddInstrument}
                                    /> &nbsp;
                                </Grid>
                                <Grid item>
                                    <Button
                                        label="Guardar"
                                        style={{'float': 'right'}}
                                        onClick={props.setGuaranteeS}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <LoanData
                            loanId={props.loanId}
                            selectedLoan={props.selectedLoan}
                            loading={props.loading}
                            ref={props.loanData}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeForChange
                            ref={props.guaranteeForChange}
                            loading={props.loading}
                            loanId={props.loanId}
                            loanType={props.selectedLoan.loanType}
                            updateGuaranteeTotal={props.updateGuaranteeTotal}
                            isPrecio24Hrs={true}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeInAccount
                            ref={props.guaranteeInAccount}
                            guaranteeAmountInLoanTotal={props.guaranteeAmount}
                            loading={props.loading}
                            loanId={props.loanId}
                            maturity={props.maturity}
                            guaranteeAmount={props.guaranteeAmount}
                            marketAmount={props.marketAmount}
                            account={props.account}
                        />
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default GuaranteeReplacement;